/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Payout_Idle_PartnersInputs */



/**
* | output |
* | --- |
* | "{count} partners with nothing this quarter" |
*
* @param {Partner_Payout_Idle_PartnersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_idle_partners = /** @type {((inputs: Partner_Payout_Idle_PartnersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_Idle_PartnersInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Partner ohne Bewegung in diesem Quartal`)
	return /** @type {LocalizedString} */ (`${i?.count} partners with nothing this quarter`)
});